import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as state from '../../../../../../../state'

/**
 * Page in Summit used to edit your notes
 */
@ngCore.Component({
  imports: [ds.button.Component],
  selector: 'atn-summit-archive-tools',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.archive.Collection}  */
  public readonly archiveEc = ngCore.inject(state.summit.archive.Collection)

  /**
   * Tracks whether there are pending changes to archive data that have not been
   * persisted
   *
   * Includes newly added archives and modifications to existing archives
   */
  public readonly hasPendingUpdates =
    this.archiveEc.plugins.editingPlugin.feature.selectors.updatesLookup.project(
      this.archiveEc.plugins.editingPlugin.feature.selectors.creationsLookup
        .asSelector,
      (updatesLookup, creationsLookup) =>
        Object.keys(updatesLookup).length > 0 ||
        Object.keys(creationsLookup).length > 0,
    )

  public creationHandler() {
    const id = ec.plugins.standard.editing.models.CreationId.generate()
    this.archiveEc.plugins.editingPlugin.feature.actions.edit
      .from('Summit.Active.Tools.Buttons.Add.Clicked')
      .dispatch({
        edit: archive => {
          if (!archive) {
            return {
              date: new ents.core.dms.data.expression.instance.definitions.DmsDate(),
              employees: [],
              name: 'New Archive',
            }
          }

          return
        },
        id,
      })
  }
}
